import { ProjectListIndicators } from './ProjectListIndicators';

export const BoxTotalsFlows = () => <ProjectListIndicators mode="cash" />;
